import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_find_footprinteventsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { typeId?: number, publishedFrom?: string, publishedTo?: string, id?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, EndProcessingDate?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, ParentEventId?: number, ProgressDescription?: string, ProgressValue?: number, PublishedDate?: string, StartProcessingDate?: string, StatusId?: number, TypeId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_find_footprintevents/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { typeId?: number, publishedFrom?: string, publishedTo?: string, id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, EndProcessingDate?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, ParentEventId?: number, ProgressDescription?: string, ProgressValue?: number, PublishedDate?: string, StartProcessingDate?: string, StatusId?: number, TypeId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_find_footprintevents/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { typeId?: number, publishedFrom?: string, publishedTo?: string, id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, EndProcessingDate?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, ParentEventId?: number, ProgressDescription?: string, ProgressValue?: number, PublishedDate?: string, StartProcessingDate?: string, StatusId?: number, TypeId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_find_footprintevents/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      typeId?: number, publishedFrom?: string, publishedTo?: string, id?: number    }) {
      return false;
    }
}
